import React from 'react';
import PriceOverride from 'src/assets/images/PriceOverride.svg';
import PriceOverrideDisabled from 'src/assets/images/PriceOverrideDisabled.svg';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import { StyledTextDiv } from 'src/pages/reportUsage/utils/reportUsage.styled';
import { useTranslation } from 'react-i18next';

const PriceOverrideButtonContainer = ({
    priceOverrideClickHandler,
    btnDisabled,
    priceOverrideReason,
    margin,
    isReportPayment,
    show,
}) => {
    const { t } = useTranslation();
    return (
        <div>
            <Button
            id={'reportUsage-record-priceOverrideButton'}
                show={show}
                width={'150px'}
                height={'36px'}
                margin={margin ? margin : '24px 0 0 0'}
                padding={'0'}
                // secondary
                 variant ={btnDisabled ? ButtonStyles?.signatureBtnDisabled : ButtonStyles?.signatureBtnEnabled}
                // backgroundColor={btnDisabled ? '#E6E6E6' : '#FFFFFF'}
                // color={btnDisabled ? '#888888' : '#1010EB'}
                // border={btnDisabled ? '1px solid #BCBCBC' : '1px solid #FFFFFF'}
                boxShadow={'0px 0px 2px #00000029'}
                borderRadius={'17px'}
                clicked={priceOverrideClickHandler}
                disabled={btnDisabled}
                fontSize={'14px'}
                ipadWidth={'160px'}
            >
                <img
                    style={{
                        height: btnDisabled && '34px',
                        width: btnDisabled && '34px',
                        marginRight: !btnDisabled && '7px',
                    }}
                    src={btnDisabled ? PriceOverrideDisabled : PriceOverride}
                    alt="priceoverride"
                />
                <div>{t('reportUsage.record.priceOverride.title')}</div>
               
            </Button>
            {priceOverrideReason && priceOverrideReason.length > 0 && (
                <div style={{ marginBottom: isReportPayment && '18px' }}>
                    <StyledTextDiv
                        color="#202124"
                        fontSize="15px"
                        padding={isReportPayment ? '0' : '10px 0 0'}
                    >
                        {t('consignmentBilling.priceOverride.reason')}
                    </StyledTextDiv>
                    <StyledTextDiv
                        color="#202124"
                        fontSize="14px"
                        fontFamily="AvenirNextWorld Regular"
                        textAlign="left"
                    >
                        {priceOverrideReason}
                    </StyledTextDiv>
                </div>
            )}
        </div>
    );
};

export default PriceOverrideButtonContainer;
